import { useTranslation } from 'react-i18next'

type AboutPreditaProps = {
  className?: string
}

export const AboutAxel = ({ className = '' }: AboutPreditaProps) => {
  const { t } = useTranslation()
  return (
    <div className={`${className}`}>
      <div className="mb-2">
        {t('about.aboutDescription')}
      </div>
      <div className="mb-2">
        {t('about.aboutAccuracy')}
      </div>
      <div className="mb-2">
        {t('about.aboutCreate')}
      </div>
    </div>
  )
}
